class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('classic');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('classic');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Terms auto-check a drawerben
document.addEventListener('click', function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const tncCheckbox = drawer.querySelector('.gm_tncContainer input[type="checkbox"]');

  if (tncCheckbox && !tncCheckbox.checked) {
    tncCheckbox.checked = true;
    tncCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
  }
}, true);

// Checkout gomb eltüntetése drawerben (AJAX refresh után is)
function hideDrawerCheckout() {
  const checkoutBtn = document.querySelector('#CartDrawer button[name="checkout"]');

  if (checkoutBtn) {
    checkoutBtn.style.display = 'none';
  }
}

// első betöltés
document.addEventListener('DOMContentLoaded', hideDrawerCheckout);

// drawer frissülés után
document.addEventListener('cart:updated', hideDrawerCheckout);

// fallback
setInterval(hideDrawerCheckout, 500);

// Firemný nákup validáció a "Tekintse meg a kosaram" gombnál
document.addEventListener('click', function (e) {

  const cartBtn = e.target.closest('a[href*="/cart"], .cart__view-cart, [name="cart"]');
  if (!cartBtn) return;

  const toggle = document.getElementById("companyToggle");
  if (!toggle || !toggle.checked) return;

  const companyName = document.querySelector('input[name="attributes[Názov firmy]"]');
  const ico = document.querySelector('input[name="attributes[IČO]"]');
  const dic = document.querySelector('input[name="attributes[DIČ]"]');

  let hasError = false;

  [companyName, ico, dic].forEach(el => {
    if (el) el.classList.remove("input-error");
  });

  if (!companyName || !companyName.value.trim()) {
    companyName?.classList.add("input-error");
    hasError = true;
  }

  if (!ico || !ico.value.trim()) {
    ico?.classList.add("input-error");
    hasError = true;
  }

  if (!dic || !dic.value.trim()) {
    dic?.classList.add("input-error");
    hasError = true;
  }

  if (hasError) {
    e.preventDefault();
    e.stopPropagation();

    alert("Prosím vyplňte Názov firmy, IČO a DIČ.");
    companyName?.focus();

    return false;
  }

}, true);
